import { Column, Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { formatCurrency } from 'app/localization/i18n';
import { Currency } from 'app/schemas/user';

import { useTranslation } from 'react-i18next';

import type { NetworkSavings } from './types';

interface SavingsCardProps {
  savings: NetworkSavings;
}

export const SavingsCard = function SavingsCard({ savings }: SavingsCardProps) {
  const { t } = useTranslation('streak');
  const formatted = formatCurrency(savings.totalEstimatedPrice, Currency.CAD, 0);

  return (
    <Row
      alignItems="center"
      backgroundColor="white"
      borderRadius="radius.xl"
      gap="spacing.general.x4"
      padding="spacing.general.x4"
    >
      <Column
        alignItems="center"
        backgroundColor="surface.brand.secondary-2.default"
        borderRadius="radius.xxl"
        height={48}
        justifyContent="center"
        width={48}
      >
        <Text fontSize={24}>💰</Text>
      </Column>
      <Column flex={1} gap="spacing.general.x1">
        <Text fontSize={20} fontWeight="bold">
          {formatted}
        </Text>
        <Text color="text.tertiary" fontSize={13}>
          {t('savedThisMonth')}
        </Text>
      </Column>
    </Row>
  );
};
